import Button from '../Button/Button'
import styles from './Keyboard.module.scss'

interface KeyboardProps {
  setValue: (digit: number) => void
  clearValue: () => void
  deleteValue: () => void
}

function Keyboard(props: KeyboardProps) {
  const { setValue, clearValue, deleteValue } = props

  return (
    <div className={styles.keyboardWrapper}>
      <div className={styles.keyboardRow}>
        <Button
          onClick={() => setValue(1)}
          label="1"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={() => setValue(2)}
          label="2"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={() => setValue(3)}
          label="3"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
      </div>
      <div className={styles.keyboardRow}>
        <Button
          onClick={() => setValue(4)}
          label="4"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={() => setValue(5)}
          label="5"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={() => setValue(6)}
          label="6"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
      </div>
      <div className={styles.keyboardRow}>
        <Button
          onClick={() => setValue(7)}
          label="7"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={() => setValue(8)}
          label="8"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={() => setValue(9)}
          label="9"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
      </div>
      <div className={styles.keyboardRow}>
        <Button
          onClick={() => setValue(0)}
          label="0"
          variant="contained"
          color="primary"
          mobile
          maxWidth
        />
        <Button
          onClick={clearValue}
          label="C"
          variant="contained"
          color="secondary"
          mobile
          maxWidth
        />
        <Button
          onClick={deleteValue}
          label={<i className="las la-backspace icon-large" />}
          variant="contained"
          color="secondary"
          mobile
          maxWidth
        />
      </div>
    </div>
  )
}
export default Keyboard
